import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flex: 1,
  },
  overlayLottie: {
    width: 156,
    height: 156,
  },
  title: {
    alignSelf: 'center',
  },
  header: {
    marginTop: 12,
  },
  QAMContainerStyle: { paddingHorizontal: 0 },
});
